import { render, staticRenderFns } from "./DOPending.vue?vue&type=template&id=f1ba55c0&scoped=true"
import script from "./DOPending.vue?vue&type=script&lang=js"
export * from "./DOPending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ba55c0",
  null
  
)

export default component.exports